import React, { useEffect, useState } from "react";

import { Dialog, Portal, CloseButton, Button, Spinner, Field, createListCollection, Box, Select } from "@chakra-ui/react";
import { floatingStyles, getGeometryTypeGeojson, removeEpochSuffix, removeFileExtension, showToast } from "../../../../../utilies/Utility";
import Type from "../../../../../utilies/Types";
import { LuFolder } from "react-icons/lu";
import { serviceCreateOrEditProjects } from "../../../../../api/services/project";
import { getEditedGeoJSON } from "../../../../../utilies/geojson/GetEditedGeojson";
import { getProjects } from "../../../../../utilies/services/project/GetProject";
import { useAppStore } from "../../../../../context/store";
import { saveLayerToServerUnified } from "../../../../../utilies/loader/layer/saveLayerToServer";

const LayersCopyToProject = () => {
  // state
  const isShowCopyToProjectDialog = useAppStore((s) => s.isShowCopyToProjectDialog);
  const currentLayer = useAppStore((s) => s.currentLayer);
  const userData = useAppStore((s) => s.userData);
  const projects = useAppStore((s) => s.projects);
  const pointCloudStyle = useAppStore((s) => s.pointCloudStyle);

  // setters
  const setIsShowCopyToProjectDialog = useAppStore.getState().setIsShowCopyToProjectDialog;
  const setCurrentLayer = useAppStore.getState().setCurrentLayer;
  const setProjects = useAppStore.getState().setProjects;

  const [formProject, setFormProject] = useState("");

  const [isProgress, setIsProgress] = useState(false);

  const [projectOptions, setProjectOptions] = useState(
    createListCollection({
      items: [],
    })
  );

  useEffect(() => {
    if (projects) {
      let temp = [];
      for (const key in projects) {
        temp.push({ label: projects[key].project_name, value: projects[key].id });
      }
      setProjectOptions(
        createListCollection({
          items: temp,
        })
      );
    }
  }, [projects]);

  const copyLayerToProject = async () => {
    setIsProgress(true);
    let listOfLayersId = [];
    for (const key in projects) {
      if (projects[key].id == formProject) {
        for (const key2 in projects[key].layers) {
          listOfLayersId.push(projects[key].layers[key2].id);
        }
      }
    }

    await saveLayerToServerUnified({
      layer: currentLayer,
      userData,
      pointCloudStyle,
      description: "",
      createFileBaseName: removeEpochSuffix(removeFileExtension(currentLayer.file_name)),
      attachFile: "always",
      sendLayerId: false,
    })
      .then((res) => {
        if (res.data.status == "failed") {
          showToast(res.data.message, Type.NOTIFICATION.WARNING);
        } else {
          showToast("Stored " + removeEpochSuffix(removeFileExtension(res.data.layer_name)), Type.NOTIFICATION.SUCCESS);
          listOfLayersId.push(res.data.layer_id);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });

    const formData = new FormData();
    formData.append(
      "data",
      JSON.stringify({
        username: userData.user.username,
        layers: [...new Set(listOfLayersId)],
      })
    );
    formData.append("project_id", formProject);

    serviceCreateOrEditProjects(formData, userData.token)
      .then((res) => {
        if (res.data.status == "success") {
          showToast(res.data.message, Type.NOTIFICATION.SUCCESS);
          getProjects({
            userData,
            setProjects,
            onSuccess: () => {
              setIsProgress(false);
              setIsShowCopyToProjectDialog(false);
            },
            onError: () => {
              setIsProgress(false);
            },
          });
        }
      })
      .catch((err) => {
        showToast(err.message, Type.NOTIFICATION.WARNING);
        console.error("Error", err);
      });
  };

  return (
    <Dialog.Root
      lazyMount
      open={isShowCopyToProjectDialog}
      closeOnInteractOutside={false}
      onOpenChange={(e) => {
        setIsShowCopyToProjectDialog(e.open);
        if (!Boolean(e.open)) {
          setCurrentLayer(null);
        }
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Copy To Project</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Field.Root mt={2}>
                <Box pos="relative" w="full">
                  <Select.Root
                    collection={projectOptions}
                    size="sm"
                    width="full"
                    onValueChange={(v) => {
                      setFormProject(v.value[0]);
                    }}
                  >
                    <Select.HiddenSelect />

                    <Select.Control>
                      <Select.Trigger>
                        <Select.ValueText placeholder={"Project"} />
                      </Select.Trigger>
                      <Select.IndicatorGroup>
                        <Select.ClearTrigger />
                        <Select.Indicator />
                      </Select.IndicatorGroup>
                    </Select.Control>

                    <Select.Positioner>
                      <Select.Content>
                        {projectOptions.items.map((item) => (
                          <Select.Item item={item} key={item.value}>
                            {item.label}
                            <Select.ItemIndicator />
                          </Select.Item>
                        ))}
                      </Select.Content>
                    </Select.Positioner>
                  </Select.Root>
                  <Field.Label css={floatingStyles}>
                    <LuFolder /> Project
                  </Field.Label>
                </Box>
              </Field.Root>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button onClick={copyLayerToProject}>{isProgress ? <Spinner size="sm" /> : "Copy"}</Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersCopyToProject;
